import React, { useState, useEffect } from "react";
import LearnContent from "../../components/Right/LearnContent";
import axios from "axios";
import SkeletonArticle from "../../components/Post_skaliton/SkeletonArticle";
import InfiniteScroll from "react-infinite-scroll-component";
import DogWithBoll from "../../../src/Assets/Images/dogwithball.gif";
import GreetingContent from "../../components/Right/GreetingContent";
const UpcomingGreetings = () => {
  const [posts, setPosts] = useState([]);
  const [loadingEvent, setLoadingEvent] = useState(true);
  const [paginate, setPaginate] = useState(1);
  const [noData, setNoData] = useState(false);
  const fetchData = () => {
    axios
      .get(`api/user/post/greeting/with-paginate/4?page=${paginate}`)
      .then((res) => {
        if (res.data.status === 200) {
          setPosts([...posts, ...res.data.post]);
          setPaginate(paginate + 1);
          setLoadingEvent(false);
          if (res.data.post.length === 0) {
            setNoData(true);
          }
        }
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <InfiniteScroll
        dataLength={posts.length}
        next={fetchData}
        hasMore={true}
        loader={ noData && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img src={DogWithBoll} style={{ height: 250, width: 500 }} />
            <h4 className="text-center text-warning">
              No Data found!
            </h4>
          </div>
        )}
        endMessage={
          <p style={{ textAlign: "center" }}>
            <b>You have seen it all</b>
          </p>
        }
      >
        <center>
          {loadingEvent &&
            [1, 2, 3, 4].map(() => <SkeletonArticle theme="dark" />)}

          {posts.map((event) => (
            <GreetingContent key={event.id} post={event} />
          ))}
        </center>
      </InfiniteScroll>
    </>
  );
};

export default UpcomingGreetings;
